import { SectionMessage, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InfoSectionWrapper = styled(SectionMessage)`
  margin-bottom: ${Spacing.S40};
`
